export const interpolate = (templateString, data) => {
    var _a, _b;
    const openingFlagIndex = templateString.indexOf('{{');
    const closingFlagIndex = templateString.indexOf('}}');
    if (openingFlagIndex === -1 || closingFlagIndex <= openingFlagIndex) {
        return templateString;
    }
    if (!data) {
        return templateString;
    }
    let result = templateString;
    for (const key in data) {
        result = result.replace(new RegExp('\\{\\{\\s*' + key + '\\s*\\}\\}', 'g'), (_b = (_a = data[key]) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '');
    }
    return result;
};
